import { render, staticRenderFns } from "./AI-DescriptionGenerator.vue?vue&type=template&id=587e9acc"
import script from "./AI-DescriptionGenerator.vue?vue&type=script&lang=js"
export * from "./AI-DescriptionGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports